<template>
  <!-- my code -->
    <!-- <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader"> -->
    <div class="wrapper-main-content">
        <!-- sidebar -->
            <div class="sidebar">
                <side-bar
                    :step="step"
                    :sidebarListLinks="sidebarListLinks"
                ></side-bar>
        </div>
        <!-- sidebar ends -->

        <!-- form -->
            <div class="main_content-form">
                <div class="manager-form-box position-relative p-4">
            <div class="card-body">
                <h1 class="head-title font-weight-bold text-center">
                Details
                </h1>
                <b-form @submit.prevent="componentFormSubmitted" class="mt-5">
                <b-form-group>
                    <template v-slot:label>
                    What trade(s) do you require? <span class="text-danger">*</span>
                    </template>
                    <treeselect
                    v-model="componentForm.trader_type"
                    :multiple="true"
                    :options="trader_type"
                    :style="{ width: '100%' }"
                    />
                    <has-error :form="form" field="trader_type"></has-error>
                </b-form-group>

                <b-form-group>
                    <template v-slot:label>
                    Job Title <span class="text-danger">*</span>
                    </template>
                    <b-form-input
                    type="text"
                    v-model="componentForm.job_title"
                    :aria-describedby="ariaDescribedby"
                    placeholder="Job Title"
                    v-bind:class="{
                        'is-invalid': form.errors.has('job_title'),
                    }"
                    ></b-form-input>
                    <has-error :form="form" field="job_title"></has-error>
                </b-form-group>

                <b-form-group>
                    <template v-slot:label>
                    Description <span class="text-danger">*</span>
                    </template>
                    <ckeditor
                    placeholder="placeholder"
                    :aria-describedby="ariaDescribedby"
                    v-model="componentForm.description"
                    :config="editorConfig"
                    v-bind:class="{
                        'is-invalid': form.errors.has('description'),
                    }"
                    >
                    </ckeditor>
                    <has-error :form="form" field="description"></has-error>
                </b-form-group>

                <b-form-group class="position-relative">
                  <b-form-file
                    placeholder="Upload Files/Documents"
                    multiple
                    @change="attachementsChanged($event, 'document')"
                    ></b-form-file>

                    <label class="upload-tab">
                      <SvgIcons
                          icon="upload-document-button"
                          width="25px"
                          height="20px"
                          svgClass="upload-docs"
                      />
                      <span class="upload-instruction">Allowed file types .pdf, .doc. Max file size 5 MB.</span>
                    </label>
                </b-form-group>

                <b-row>
                    <div
                    class="up-box d-flex mr-2 ml-2"
                    v-for="(file, idx2) in componentForm.attachements"
                    :key="'qd-file' + '-' + idx2"
                    >
                    <p>{{ file.name }}</p>
                    <SvgIcons
                        icon="insurance-document-close"
                        svgClass="ml-2"
                        style="margin-top: 2px"
                        @click.native="removeMedia(file, 'document')"
                    />
                    </div>
                </b-row>


                <b-form-group class="position-relative">
                  <b-form-file
                    placeholder="Upload Photo"
                    multiple
                    @change="attachementsChanged($event, 'photo')"
                    ></b-form-file>

                    <label class="upload-tab">
                    <SvgIcons
                        icon="upload-document-button"
                        width="25px"
                        height="20px"
                        svgClass="upload-docs"
                    />
                      <span class="upload-instruction">Allowed file types .jpg, .png. Max file size 5 MB.</span>

                    </label>
                </b-form-group>

                <b-row class="mb-3">
                    <div
                    class="up-box d-flex mr-2 ml-2"
                    v-for="(file, idx2) in componentForm.site_photos"
                    :key="'qp-file' + '-' + idx2"
                    >
                    <p>{{ file.name }}</p>
                    <SvgIcons
                        icon="insurance-document-close"
                        svgClass="ml-2"
                        style="margin-top: 2px"
                        @click.native="removeMedia(file, 'photo')"
                    />
                    </div>
                </b-row>

                <div class="builder-component mb-4" v-if="!workOrder">
                    <b-form-group v-if="!workOrder">
                    <template v-slot:label> Site Access Contact Name </template>
                    <b-form-input
                        type="text"
                        v-model="componentForm.site_contact_name"
                        :aria-describedby="ariaDescribedby"
                        placeholder="Site Access Contact Name"
                        v-bind:class="{
                        'is-invalid': form.errors.has('site_contact_name'),
                        }"
                    ></b-form-input>
                    <has-error :form="form" field="site_contact_name"></has-error>
                    </b-form-group>

                    <b-form-group v-if="!workOrder">
                    <template v-slot:label> Site Access Email </template>
                    <b-form-input
                        type="text"
                        v-model="componentForm.site_access_email"
                        :aria-describedby="ariaDescribedby"
                        placeholder="Site Access Email"
                        v-bind:class="{
                        'is-invalid': form.errors.has('site_access_email'),
                        }"
                    ></b-form-input>
                    <has-error :form="form" field="site_access_email"></has-error>
                    </b-form-group>

                    <b-form-group v-if="!workOrder">
                    <template v-slot:label> Site Access Contact Phone</template>
                    <b-form-input
                        type="text"
                        v-model="componentForm.formattedSiteContactPhone"
                        :aria-describedby="ariaDescribedby"
                        placeholder="Site Access Contact Phone"
                        v-bind:class="{
                        'is-invalid': form.errors.has('site_access_contact'),
                        }"
                        @keyup="formatPhone"
                    ></b-form-input>
                    <has-error
                        :form="form"
                        field="site_access_contact"
                    ></has-error>
                    </b-form-group>
                </div>

                <b-form-group v-if="!workOrder">
                    <template v-slot:label>
                    No. of quotes required <span class="text-danger">*</span>
                    </template>
                    <b-form-input
                    type="number"
                    v-model="componentForm.total_quotes_required"
                    :aria-describedby="ariaDescribedby"
                    placeholder="No. of quotes required"
                    v-bind:class="{
                        'is-invalid': form.errors.has('total_quotes_required'),
                    }"
                    ></b-form-input>
                    <has-error
                    :form="form"
                    field="total_quotes_required"
                    ></has-error>
                    <p
                    class="mt-1"
                    style="color: #d62323"
                    v-if="componentForm.total_quotes_required > 3"
                    >
                    Quote fee will apply, see T&Cs.
                    </p>
                </b-form-group>

                <b-form-group v-if="!workOrder" label="Quote Reply To">
                    <treeselect
                    :multiple="false"
                    :options="quoteReplyTo"
                    placeholder="Choose managers email..."
                    v-model="componentForm.reply_to_email"
                    :style="{ width: '100%' }"
                    v-bind:class="{
                        'is-invalid': form.errors.has('reply_to_email'),
                    }"
                    />
                    <has-error :form="form" field="reply_to_email"></has-error>
                </b-form-group>

                <div class="btn-actions d-flex justify-content-between mt-5">
                    <b-button
                    class="back-btn"
                    :disabled="form.busy"
                    type="button"
                    variant="primary"
                    @click="$router.go(-1)"
                    >Back
                    </b-button>

                    <b-button
                    class="btn-grad btn-next"
                    :disabled="form.busy"
                    type="submit"
                    variant="primary"
                    >Next
                    </b-button>
                </div>
                </b-form>
            </div>
            </div>
            </div>
        <!-- form ends -->
    </div>
  <!-- my code starts -->
  <!-- </b-overlay> -->
</template>

<script>
Vue.use(CKEditor);
import NavBar from "../../includes/NavBar.vue";
import SideBar from "../../includes/SideBar.vue";
import FooterComponent from "../../../includes/FooterComponent.vue";
import { HasError } from "vform";
import _ from "lodash";
import { Treeselect, ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import CKEditor from "ckeditor4-vue";
import SvgIcons from "@frontendPages/includes/SvgIconsComponent.vue";
import phoneNoMixin from "../../../../../mixins/phoneNoMixin.js";


export default {
  props: [
    "form",
    "step",
    "sidebarListLinks",
    "eventParentToChildComponentFrom",
    "workOrder",
  ],
  mixins: [phoneNoMixin],
  components: {
    NavBar,
    FooterComponent,
    SideBar,
    HasError,
    Treeselect,
    CKEditor,
    SvgIcons,
  },
  data() {
    return {
        editorConfig: {
            disableNativeSpellChecker: false,
            toolbar: [
                {name: "basicstyles", items: ["Bold", "Italic", "Strike"]},
                {name: "clipboard", items: ["Undo", "Redo"]},
                {
                    name: "paragraph",
                    items: ["NumberedList", "BulletedList", "-", "Blockquote"],
                },
            ],
        },
      componentForm: {
        trader_type: [],
        job_title: "",
        description: "",
        site_contact_name: "",
        site_access_contact: "",
        site_access_email: "",
        reply_to_email: "",
        total_quotes_required: this.workOrder ? "1" : "3",
        attachements: [],
        site_photos: [],
        formattedSiteContactPhone: "",
      },
      trader_type: [],
      quoteReplyTo: [],
    };
  },
  mounted() {
    _.forEach(this.form, (value, field) => {
      if (field in this.componentForm) {
        this.componentForm[field] = value;
      }
    });

    //Loading categories and manager(Quote to reply)
    this.loadCategories();
    this.loadReplyToManager();

    //Called by parent from index page
    this.eventParentToChildComponentFrom.$on(
      "event-parent-child-componentform",
      this.eventFromParentToChildComponentForm
    );
  },
  methods: {
    componentFormSubmitted() {
      this.$emit("componentFormSubmitted", this.componentForm, 3, 1);
    },
    eventFromParentToChildComponentForm(value) {
      _.forEach(value.data, (value, field) => {
        if (field in this.componentForm) {
          this.componentForm[field] = value;
        }
      });
    },
    loadCategories() {
      axios
        .post("api/content/getBusinessCategories", { load_children: 1 })
        .then((response) => {
          this.trader_type = response.data.categories.map((category) => {
            if (category.children.length > 0) {
              return {
                id: category.id,
                label: category.name,
                children: category.children.map((children) => {
                  return {
                    id: children.id,
                    label: children.name,
                  };
                }),
              };
            } else {
              return {
                id: category.id,
                label: category.name,
              };
            }
          });
        });
    },
    loadReplyToManager() {
      axios.post("api/content/getReplyToManagers").then((response) => {
        this.quoteReplyTo = response.data.business_users.map((businessUser) => {
          return {
            id: businessUser.id,
            label: businessUser.email,
          };
        });
      });
    },
    // loadCategoriesOptions({ action, searchQuery, callback }) {
    //     if (action === ASYNC_SEARCH) {
    //         axios
    //             .post("api/content/getBusinessCategories", {
    //                 load_children: 1,
    //                 search_query: searchQuery
    //             })
    //             .then(response => {
    //                 let options = response.data.categories.map(category => {
    //                     return {
    //                         id: category.id,
    //                         label: category.name,
    //                         children: category.children.map(children => {
    //                             return {
    //                                 id: children.id,
    //                                 label: children.name
    //                             };
    //                         })
    //                     };
    //                 });
    //                 callback(null, options);
    //             });
    //     }
    // },
    attachementsChanged: function (event, file_type) {
    //  this.$emit('emitLoader', true);
      this.$root.$data.bsLoader = true;
      if (!event.target.files.length) return;
      var input = event.target.files; //For Attachment
      input &&
        _.forEach(input, (file) => {
          const formData = new FormData(); //For uploading in storage
          formData.append("upload", file);
          formData.append("quote_id", this.$route.params.id);
          formData.append("file_type", file_type);

          axios
            .post("api/manager/quote/addMediaToQuote", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
               this.$emit('emitLoader', false);
              let extension = file.name.split(".").pop();
              if (file_type == "document") {
                this.componentForm.attachements.push({
                  extension: extension,
                  name: file.name,
                  uuid: response.data.uuid,
                });
              }
              if (file_type == "photo") {
                this.componentForm.site_photos.push({
                  extension: extension,
                  name: file.name,
                  uuid: response.data.uuid,
                });
              }
            this.$root.$data.bsLoader = false;
        }).catch((err) => {
          this.$root.$data.bsLoader = false;
      });
    });
      event.target.value = "";
      // console.log(this.componentForm.attachements);
      // event.target.form.reset();
    },
    removeMedia(file, file_type) {
      this.$root.$data.bsLoader = true;
      console.log(this.componentForm.attachements);
      if (file.uuid) {
        axios
          .post("api/manager/quote/deleteMedia", { file })
          .then((response) => {
            if (file_type == "photo") {
              this.componentForm.site_photos.splice(
                this.componentForm.site_photos.indexOf(file),
                1
              );
            } else if (file_type == "document") {
              this.componentForm.attachements.splice(
                this.componentForm.attachements.indexOf(file),
                1
              );
            }
            this.$root.$data.bsLoader = false;
          }).catch((err) => {
          this.$root.$data.bsLoader = false;
        });
      } else {
        if (file_type == "photo") {
          this.componentForm.site_photos.splice(
            this.componentForm.site_photos.indexOf(file),
            1
          );
        } else if (file_type == "document") {
          this.componentForm.attachements.splice(
            this.componentForm.attachements.indexOf(file),
            1
          );
        }
      }
    },
    formatPhone() {
      this.componentForm.site_access_contact = this.componentForm
        .formattedSiteContactPhone
        ? this.getPhoneDigitsOnly(this.componentForm.formattedSiteContactPhone)
        : null;
      this.componentForm.formattedSiteContactPhone = this.componentForm
        .site_access_contact
        ? this.formatPhoneForAustralia(this.componentForm.site_access_contact)
        : null;
    },
  },
};
</script>
